// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@west/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

listStyles.wrapper = {};

listStyles.cardList = {
    gridContainer: {
        gap: 22,
        css: css`
            padding-bottom: 22px;
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            margin: 0;
            width: 100%;
            padding: 0;
            ${xScreen("lte", "md")} {
                width: 50%;
            }
            ${xScreen("lte", "xs")} {
                width: 100%;
                border-bottom: 1px solid ${color("common.border")};
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            ${xScreen("lte", "md")} {
                height: 100%;
            }
        `,
    },
};

listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            border: none;
            height: 100%;
            padding: 0;
            width: 100%;

            ${xScreen("lte", "xs")} {
                padding-bottom: 12px;
                border-bottom: 1px solid ${color("common.border")};
            }
        `,
    },
    gridItem: {
        width: [12, 6, 4, 4, 4],
        css: css`
            padding: 11px; // override ootb style

            ${xScreen("lte", "sm")} {
                position: relative;
                &:after {
                    content: "";
                    position: absolute;
                    width: 100%;
                    left: 0;
                    right: 0;
                    top: 100%;
                    height: 1px;
                    background: ${color("common.border")};
                }
            }

            ${xScreen("lte", "xs")} {
                &:after {
                    display: none;
                }
            }
        `,
    },
};

listStyles.adsCardContainerStyles = {
    gridItem: {
        width: 12,
    },
};

listStyles.adsImage = {
    css: css`
        height: 180px;
        width: 100%;
        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};
